/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=02b97158&scoped=true"
import script from "./taskDetail.vue?vue&type=script&lang=js"
export * from "./taskDetail.vue?vue&type=script&lang=js"
import style1 from "./taskDetail.vue?vue&type=style&index=1&id=02b97158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b97158",
  null
  
)

export default component.exports